export default __webpack_public_path__ + "static/media/06native.7fb8e756.png";